export const OPEN_DIALER = "OPEN_DIALER";
export const CLOSE_DIALER = "CLOSE_DIALER";
export const TOGGLE_DIALER = "TOGGLE_DIALER";
export const UPDATE_CALL_STATUS = "UPDATE_CALL_STATUS";
export const SET_PHONE_NUMBER = "SET_PHONE_NUMBER";
